<div class="meeting-event-code">
  <div class="meeting-event-code-field-input">
    <idp-info-tooltip
      [infoModal]="bookWidgetAem.meetingEventCodeField.infoModal"
      [attr.aria-label]="
        bookWidgetAem.meetingEventCodeField.meetingEventCode +
        ' ' +
        bookWidgetAem.helpIconAriaLabel
      "
      [toolTipPosition]="toolTipPosition"
    ></idp-info-tooltip>
    <input
      machInput
      [attr.aria-label]="bookWidgetAem.meetingEventCodeField.meetingEventCode"
      [placeholder]="bookWidgetAem.meetingEventCodeField.placeholder"
      [disabled]="bookWidgetFields.meetingEventCodeField.disable"
      [title]="bookWidgetAem.meetingEventCodeField.meetingEventCode"
      [value]="bookWidgetFields.meetingEventCodeField.meetingEventCodeValue"
      [floatingLabel]="false"
      [error]="
        !!bookWidgetFields.meetingEventCodeField.fieldErrorInfo?.errorMessage
      "
      [idpErrorState]="
        !!bookWidgetFields.meetingEventCodeField.fieldErrorInfo?.errorMessage
      "
      maxlength="5"
      (change)="meetingEventCodeChange.emit($event)"
    />
  </div>
  <div
    *ngIf="bookWidgetFields.meetingEventCodeField.fieldErrorInfo?.errorMessage"
    class="meeting-event-code-field-error"
  >
    {{ bookWidgetFields.meetingEventCodeField.fieldErrorInfo?.errorMessage }}
  </div>
  <ng-container
    *ngIf="bookWidgetFields.meetingEventCodeField.disclaimerMessage"
  >
    <div
      class="meeting-event-code-field-disclaimer"
      [innerHTML]="bookWidgetFields.meetingEventCodeField.disclaimerMessage"
    ></div>
  </ng-container>
</div>
